import { useOutsideClick } from './useOutsideClick';
export default useOutsideClick;
